import moment from 'moment';
import { formatCurrency } from '../InvoicesAndStatements/helper';
import { INVOICE_STATUS_MAPPER, INVOICE_STATUS } from 'constants/salesforceInvoices';

const formatSalesforceInvoicesSummaryList = salesforceInvoicesSummaryList => {
  if (!salesforceInvoicesSummaryList) return [];
  return salesforceInvoicesSummaryList.map(invoice => ({
    ...invoice,
    invoiceStatus:
      INVOICE_STATUS_MAPPER[invoice.invoiceStatus.toUpperCase().replace(/\s/g, '')] ||
      INVOICE_STATUS.OTHER,
    invoiceDate: moment.utc(invoice.invoiceDate).format('DD/MM/YYYY'),
    outstandingAmount: formatCurrency(invoice.currencyCode, invoice.outstandingAmount),
    totalAmount: formatCurrency(invoice.currencyCode, invoice.totalAmount),
  }));
};

const convertDataToPDF = (data, fileName) => {
  if (data) {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(url);
  }
};

const getTranslationKeyByInvoiceStatus = status => {
  if (!status) return;
  let translationKey;
  switch (status.toLowerCase()) {
    case 'other':
      translationKey = 'corporateAccounts.corporateClient.industryOption.other';
      break;
    case 'open':
      translationKey = 'corporateAccounts.salesforceInvoices.status.open';
      break;
    case 'paidinfull':
      translationKey = 'corporateAccounts.salesforceInvoices.status.paidInFull';
      break;
    case 'deposited':
      translationKey = 'corporateAccounts.salesforceInvoices.status.deposited';
      break;
    default:
      break;
  }
  return translationKey;
};
export { formatSalesforceInvoicesSummaryList, convertDataToPDF, getTranslationKeyByInvoiceStatus };
